const fetchError = (statusCode, msg = "") => ({
  type: "FETCH_ERROR",
  payload: {
    statusCode,
    msg,
  },
});

export default fetchError;
